import { Navigate, Outlet } from "react-router-dom"

import { useAuthStore } from "@/features/auth/store/auth-store"

export const ProtectedRoute = () => {
  // Agora, o estado de autenticação vem do nosso store global (Zustand).
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  if (isAuthenticated) {
    return <Outlet />
  }

  // Se não estiver autenticado, redireciona para a página de login.
  // A propriedade `replace` evita que o usuário possa voltar para a rota protegida
  // usando o botão "voltar" do navegador.
  return <Navigate to="/login" replace />
}